import { MDXEditorMethods } from "@mdxeditor/editor";
import { HidroDXEditor } from "../edit";
import { useEffect, useRef, useState } from "react";
import { useBarragemContext, useUserContext } from "../../context";
import { Box, Divider, Typography } from "@mui/material";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog, LoadingModal } from "../modals";
import { CompanyData } from "../../pages";

export const DescricaoEmpreendimento: React.FC = () => {
  const api = useApi();
  const user = useUserContext();
  const { barragem } = useBarragemContext();

  const editorRef = useRef<MDXEditorMethods>(null);
  const [error, setError] = useState<RequestError>();
  const [company, setCompany] = useState<CompanyData>();

  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    api.company.company(barragem.idEmpreendimento).then((value) => {
      if ("error" in value) {
        setError(value);
        return;
      }
      setCompany(value);
    });
  }, [barragem]);

  useEffect(() => {
    if (!company) return;
    editorRef.current?.setMarkdown(company.descricao);
  }, [company]);

  if (!barragem || !user || "error" in user || "error" in barragem) {
    return <></>;
  }

  if (!company) return <LoadingModal open={true} message="Aguardando dados do empreendimento" />;

  return <>
    {/* Error */}
    {error && <ErrorOnDialog
      open={Boolean(error)}
      error={error.error}
      message={error.message}
      onClose={() => setError(undefined)}
    />}

    <Box sx={{
      gap: "1em",
      width: "100%",
      height: "100%",
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
    }}>
      {/* Nome e Logo */}
      <Box sx={{
        gap: "1em",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
      }}>
        <img
          height={"55em"}
          src={company.logo}
          style={{ objectFit: "contain" }}
        />
        <Typography fontSize={26} fontWeight={600}>
          {company.nome}
        </Typography>
      </Box>

      <Divider />

      {/* Imagem */}
      <img
        width={"100%"}
        height={"250em"}
        src={company.banner}
        style={{ objectFit: "cover" }}
      />

      {/* Editor, apenas exibindo */}
      <div style={{
        flex: 1,
        width: "100%",
        height: "100%",
        minHeight: "70vh",
        overflowY: "auto",
        textAlign: "justify",
      }}>
        <HidroDXEditor readOnly={true} editorRef={editorRef} />
      </div>
    </Box>
  </>;
};
